import { render } from "./our-team.vue?vue&type=template&id=300ce4be"
import script from "./our-team.vue?vue&type=script&lang=js"
export * from "./our-team.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__